import { BehaviorSubject, catchError, map, Observable, switchMap } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import {
  CertAuthClientService,
  NIASBizAPIDtosAuthResponseDto,
  NIASBizAPIDtosUserDataDto,
  SessionApiClientService,
} from '../api/v1';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class SupervisorAuthService {
  private router: Router = inject(Router);
  private certAuthClientService: CertAuthClientService = inject(CertAuthClientService);
  private sessionApiClientService: SessionApiClientService = inject(SessionApiClientService);

  private user: BehaviorSubject<NIASBizAPIDtosUserDataDto | null> =
    new BehaviorSubject<NIASBizAPIDtosUserDataDto | null>(null);

  public isAuthenticate$: Observable<boolean> = this.user.pipe(map((x) => x != null));

  public get isAuthenticate(): boolean {
    return this.user.getValue() != null;
  }

  public get userValue(): NIASBizAPIDtosUserDataDto | null {

    var sessionValue = sessionStorage.getItem("supervisorUser") ;

    
    if(sessionValue){
      const userDto : NIASBizAPIDtosUserDataDto = JSON.parse(sessionValue);
      this.saveUser(userDto)
      return this.user.getValue();
    }    
    return null;
  }

  public saveUser(user: NIASBizAPIDtosUserDataDto) {
    if(user && user.UserRoles){
        user.UserRoles = user.UserRoles.map(item => item === 'Supervisor' ? 'Kontrolor' : item);
    }
    sessionStorage.setItem("supervisorUser", JSON.stringify(user));
    this.user.next(user);
  }

  public loginWithCert() {
    return this.certAuthClientService.certAuthCertificate().pipe(
      switchMap((res: NIASBizAPIDtosAuthResponseDto) => {
        this.user.next(res.User_data!);
        return this.sessionApiClientService.sessionApiGet().pipe(
          map((userDataDTO: NIASBizAPIDtosUserDataDto) => {
            this.user.next(userDataDTO);
            this.saveUser(userDataDTO);
            return true;
          })
        );
      })
    );
  }

  public logout() {
    sessionStorage.removeItem("supervisorUser");
    this.sessionApiClientService.sessionApiLogout().subscribe({
      next: (res) => {
        this.user.next(null);
        this.router.navigate(['/']);
      },
    });
  }
}
